module.exports = __webpack_public_path__ + "img/evening-bg.2211b70a.png";